import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../ResponsiveImage';
import { socialMediaIcons } from './constants';
import {
  StyledFooterColumn,
  BusinessHours,
  Content,
  ColumnTitle,
  SocialIcon,
} from './styles';
import { FooterLink } from './FooterLink';

export const FooterColumn = ({ links, businessHours, content, title }) => (
  <StyledFooterColumn>
    <ColumnTitle>{title}</ColumnTitle>
    {businessHours && <BusinessHours>{businessHours}</BusinessHours>}
    {content && <Content>{content}</Content>}
    {links.map(({ path, ...linkProps }, idx) => (
      <FooterLink
        {...linkProps}
        href={path}
        key={path}
        columnTitle={title}
        index={idx}
      />
    ))}
  </StyledFooterColumn>
);

export const SocialColumn = () => (
  <StyledFooterColumn>
    <ColumnTitle>Social</ColumnTitle>
    {socialMediaIcons.map(({ src, alt, href }, i) => (
      <SocialIcon key={i} href={href} target="_blank">
        <ResponsiveImage src={src} alt={alt} height={20} width={20} />
      </SocialIcon>
    ))}
  </StyledFooterColumn>
);

SocialColumn.displayName = 'SocialColumn';

FooterColumn.displayName = 'FooterColumn';

FooterColumn.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
  businessHours: PropTypes.node,
  content: PropTypes.node,
  title: PropTypes.string.isRequired,
};
